import React from 'react';
import { arrayOf, object } from 'prop-types';
import styled from 'styled-components';
import shortid from 'shortid';

import BenefitSection from './BenefitSectionContainer';

const Container = styled.div`
  display: inline-block;
  width: 360px;

  @media(min-width: 1000px) {
    display: none;
  }
`;

const BenefitAccordion = ({ benefits }) => (
  <Container>
    {benefits.map(benefit => <BenefitSection key={shortid.generate()} benefit={benefit} />)}
  </Container>
);

export default BenefitAccordion;

BenefitAccordion.propTypes = {
  benefits: arrayOf(object).isRequired,
};
